import { render, staticRenderFns } from "./DepartureTabsExtras.vue?vue&type=template&id=b21d24f2&scoped=true&"
import script from "./DepartureTabsExtras.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsExtras.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsExtras.vue?vue&type=style&index=0&id=b21d24f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21d24f2",
  null
  
)

export default component.exports